import { createSelector } from '@reduxjs/toolkit';

const selectReportsState = (store) => {
  return store.reportsDetailsReducer;
};

export const selectPayrollData = createSelector(
  selectReportsState,
  ({ payrollData, loading }) => ({ payrollData, loading })
);

export const selectCallbackData = createSelector(
  selectReportsState,
  ({ callbackReportData, loadingCallbackReport }) => ({
    callbackReportData,
    loadingCallbackReport,
  })
);

export const selectPtoBalancesData = createSelector(
  selectReportsState,
  ({ ptoBalances, loadingpPtoBalances }) => ({
    ptoBalances,
    loadingpPtoBalances,
  })
);

export const selectPtoBalancesEmployeeData = createSelector(
  selectReportsState,
  ({ ptoBalancesEmployee, loadingPtoBalancesEmployee }) => ({
    ptoBalancesEmployee,
    loadingPtoBalancesEmployee,
  })
);

export const selectPtoBalancesEmployeeCSVData = createSelector(
  selectReportsState,
  ({ ptoBalancesEmployeeCsv, loadingPtoBalancesEmployeeCsv }) => ({
    ptoBalancesEmployeeCsv,
    loadingPtoBalancesEmployeeCsv,
  })
);

export const selectAbsertCodesList = createSelector(
  selectReportsState,
  ({ absertCodesList, loadingAbsertCodesList }) => ({
    absertCodesList,
    loadingAbsertCodesList,
  })
);

export const selectPtoReportData = createSelector(
  selectReportsState,
  ({ ptoReportData, loadingPtoReport }) => ({ ptoReportData, loadingPtoReport })
);

export const selectEmployeeData = createSelector(
  selectReportsState,
  ({ employeeList, loadingEmployeeList }) => ({
    employeeList,
    loadingEmployeeList,
  })
);

export const selectPayperiodData = createSelector(
  selectReportsState,
  ({ payperiod, loadingPayperiod }) => ({
    payperiod,
    loadingPayperiod,
  })
);

export const selectCsvReportData = createSelector(
  selectReportsState,
  ({ csvPtoReport, loadingCsvPtoReport }) => ({
    csvPtoReport,
    loadingCsvPtoReport,
  })
);

export const selectMunisCsvReportData = createSelector(
  selectReportsState,
  ({ munisCsvReport, isLoadingMunisCsvData }) => ({
    munisCsvReport,
    isLoadingMunisCsvData,
  })
);

export const selectOvertimeReportData = createSelector(
  selectReportsState,
  ({ overtimeReportData, loadingOvertimeReport }) => ({
    overtimeReportData,
    loadingOvertimeReport,
  })
);

export const selectOvertimeListMasterReportData = createSelector(
  selectReportsState,
  ({ overtimeListMasterReport, isLoadingOvertimeListMasterReport }) => ({
    overtimeListMasterReport,
    isLoadingOvertimeListMasterReport,
  })
);

export const selectPayrollReportData = createSelector(
  selectReportsState,
  ({ payrollReportData, loadingPayrollReport }) => ({
    payrollReportData,
    loadingPayrollReport,
  })
);

export const selectCsvPayrollReportData = createSelector(
  selectReportsState,
  ({ csvPayrollReport, loadCsvPayrollReport }) => ({
    csvPayrollReport,
    loadCsvPayrollReport,
  })
);

export const selectCsvOvertimeReportData = createSelector(
  selectReportsState,
  ({ csvOvertimeReport, loadingCsvOvertimeReport }) => ({
    csvOvertimeReport,
    loadingCsvOvertimeReport,
  })
);

export const selectMunisReportData = createSelector(
  selectReportsState,
  ({ munisReportData, isMunisReportDataLoading }) => ({
    munisReportData,
    isMunisReportDataLoading,
  })
);

export const selectSwapShiftsReportsData = createSelector(
  selectReportsState,
  ({ swapShiftsData, isLoadingSwapShifts }) => ({
    swapShiftsData,
    isLoadingSwapShifts,
  })
);

export const selectWeeklyPayrollReportData = createSelector(
  selectReportsState,
  ({ weeklyPayrollReportData, loadingWeeklyPayrollReport }) => ({
    weeklyPayrollReportData,
    loadingWeeklyPayrollReport,
  })
);

export const selectWeeklyPayrollCsvReportData = createSelector(
  selectReportsState,
  ({ weeklyPayrollCsvReport, isLoadingWeeklyPayrollCsvData }) => ({
    weeklyPayrollCsvReport,
    isLoadingWeeklyPayrollCsvData,
  })
);

export const selectAdjustHoursReportData = createSelector(
  selectReportsState,
  ({ adjustHours, isLoadingAdjustHours }) => ({
    adjustHours,
    isLoadingAdjustHours,
  })
);

export const selectAvailabilityDetailReportData = createSelector(
  selectReportsState,
  ({ availabilityDetail, isLoadingAvailabilityDetail }) => ({
    availabilityDetail,
    isLoadingAvailabilityDetail,
  })
);

export const selectAvailabilitySummaryReportData = createSelector(
  selectReportsState,
  ({ availabilitySummary, isLoadingAvailabilitySummary }) => ({
    availabilitySummary,
    isLoadingAvailabilitySummary,
  })
);

export const selectMiltonReport = createSelector(
  selectReportsState,
  ({ miltonReportData, isLoadingMiltonReport }) => ({
    miltonReportData,
    isLoadingMiltonReport,
  })
);

export const selectCSVMiltonReport = createSelector(
  selectReportsState,
  ({ miltonCSVReportData, isLoadingCSVMiltonReport }) => ({
    miltonCSVReportData,
    isLoadingCSVMiltonReport,
  })
);

export const selectCharltonReport = createSelector(
  selectReportsState,
  ({ charltonReportData, isLoadingCharltonReport }) => ({
    charltonReportData,
    isLoadingCharltonReport,
  })
);

export const selectCSVCharltonReport = createSelector(
  selectReportsState,
  ({ charltonCSVReportData, isLoadingCSVCharltonReport }) => ({
    charltonCSVReportData,
    isLoadingCSVCharltonReport,
  })
);

export const selectWoburnMunisOvertimeReport = createSelector(
  selectReportsState,
  ({
    woburnMunisOvertimeReportData,
    isWoburnMunisOvertimeReportDataLoading,
  }) => ({
    woburnMunisOvertimeReportData,
    isWoburnMunisOvertimeReportDataLoading,
  })
);

export const selectCSVWoburnMunisOvertimeReport = createSelector(
  selectReportsState,
  ({
    woburnMunisOvertimeCSVReportData,
    isWoburnMunisOvertimeCSVReportDataLoading,
  }) => ({
    woburnMunisOvertimeCSVReportData,
    isWoburnMunisOvertimeCSVReportDataLoading,
  })
);

export const selectWoburnPTOReport = createSelector(
  selectReportsState,
  ({ woburnPTOdata, isWoburnPTODataLoading }) => ({
    woburnPTOdata,
    isWoburnPTODataLoading,
  })
);

export const selectCSVWoburnPTOReport = createSelector(
  selectReportsState,
  ({ woburnPtoCSVData, isWoburnPtoCSVDataLoading }) => ({
    woburnPtoCSVData,
    isWoburnPtoCSVDataLoading,
  })
);

export const selectWoburnReport = createSelector(
  selectReportsState,
  ({ woburnReportData, isWoburnReportDataLoading }) => ({
    woburnReportData,
    isWoburnReportDataLoading,
  })
);

export const selectCSVWoburnReport = createSelector(
  selectReportsState,
  ({ woburnCSVData, isWoburnCSVDataLoading }) => ({
    woburnCSVData,
    isWoburnCSVDataLoading,
  })
);

export const selectAvailableReports = createSelector(
  selectReportsState,
  ({ availableReports, isAvailableReportsLoading }) => ({
    availableReports,
    isAvailableReportsLoading,
  })
);
export const selectWoburnOvertimeReport = createSelector(
  selectReportsState,
  ({ woburnOvertimeReportData, isWoburnOvertimeReportLoading }) => ({
    woburnOvertimeReportData,
    isWoburnOvertimeReportLoading,
  })
);

export const selectCSVWoburnOvertimeReport = createSelector(
  selectReportsState,
  ({ woburnOvertimeCSVReportData, isLoadingCSVWoburnOvertimeReport }) => ({
    woburnOvertimeCSVReportData,
    isLoadingCSVWoburnOvertimeReport,
  })
);

export const selectWoburnReassignmentReportData = createSelector(
  selectReportsState,
  ({
    woburnReassignmentReportData,
    isLoadingWoburnReassignmentReportData,
  }) => ({
    woburnReassignmentReportData,
    isLoadingWoburnReassignmentReportData,
  })
);

export const selectCSVWoburnReassignmentReportData = createSelector(
  selectReportsState,
  ({ CSVWoburnReassignmentReport, isLoadingCSVWoburnReassignmentReport }) => ({
    CSVWoburnReassignmentReport,
    isLoadingCSVWoburnReassignmentReport,
  })
);
export const selectWoburnMunisPtoReport = createSelector(
  selectReportsState,
  ({ woburnMunisPtoData, isWoburnMunisPtoDataLoading }) => ({
    woburnMunisPtoData,
    isWoburnMunisPtoDataLoading,
  })
);

export const selectWoburnMunisPtoCSVReport = createSelector(
  selectReportsState,
  ({ woburnMunisPtoCSVData, isWoburnMunisPtoCSVLoading }) => ({
    woburnMunisPtoCSVData,
    isWoburnMunisPtoCSVLoading,
  })
);

export const selectPtoOptionsList = createSelector(
  selectReportsState,
  ({ ptoOptionsList, isPtoOptionsListLoading }) => ({
    ptoOptionsList,
    isPtoOptionsListLoading,
  })
);